// Context provider
import React from 'react';
// import 'react-app-polyfill/stable';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import App from './App';
import { bootstrapLingui } from './locales/bootstrapLingui';

const container = document.getElementById('root');
const root = createRoot(container);

const renderApp = async () => {
  await bootstrapLingui(window.location.pathname);

  root.render(
    <CookiesProvider>
      <App />
    </CookiesProvider>
  );
};

void renderApp();
